var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaq = function SvgFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.696
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 10a7.999 7.999 0 1 0 15.998 0A7.999 7.999 0 0 0 2 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.826 10a4.174 4.174 0 1 0 8.349 0 4.174 4.174 0 0 0-8.349 0zm10.729-4.588L13.767 8.2M11.8 6.232l2.796-2.796M5.412 16.555 8.2 13.767M6.233 11.8l-2.788 2.788m11.148 1.964-2.788-2.788m1.965-1.97 2.789 2.789M3.448 5.407l2.787 2.788M8.206 6.23 5.417 3.441"
  }))));
};
export default SvgFaq;